window.changeColorSelector = '.jsNewCarsFilterChooseColor';

$(function () {
    try {

        $('#WidgetNewCarsFilter').on('change', 'select', function () {
            $("#filter-results").html("");
            $("[data-action=show-all-cars]").hide();
            $("#filter_loader").show();
            $(this).trigger('submit');
        });

        $(window.changeColorSelector).on('click', function (e) {
            $(`${window.changeColorSelector}.color--choosed`).removeClass('color--choosed');
            $(this).addClass('color--choosed');
            $("#filter-results img").attr('src', $(this).data('image-url'));
            setColor();
        });

        setColor();
    } catch (e) {
        console.error(e)
    }


})

function setColor() {
    let colorName = $(`${window.changeColorSelector}.color--choosed`).attr('title');
    $('#filterColorField').val(colorName);
}







